import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setProducts } from '../store/slices/product-slice';

const useProducts = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const baseUrl = process.env.REACT_APP_API_URL || 'https://apitienda.zapateriaselene.com';
        const response = await fetch(`${baseUrl}/api/products?per_page=100`);
        const data = await response.json();
        
        if (data.success) {
          console.log('Raw API data:', data.data); // Cambiar data.data.data por data.data
          console.log('Total products from API:', data.data.length); // Cambiar data.data.data.length por data.data.length
          
          const transformedProducts = data.data.map(product => ({ // Cambiar data.data.data.map por data.data.map
            id: product.id,
            sku: product.sku,
            name: product.name,
            price: parseFloat(product.price),
            sale_price: product.sale_price ? parseFloat(product.sale_price) : null,
            discount: product.sale_price ? 
              Math.round(((product.price - product.sale_price) / product.price) * 100) : 0,
            new: product.is_new || (new Date(product.created_at) >= new Date(Date.now() - 30*24*60*60*1000)),
            is_new: product.is_new,
            saleCount: product.sale_count || 0,
            sale_count: product.sale_count || 0,
            rating: 5,
            ratingCount: 1,
            // Guardamos la categoría como un array de objetos para mantener compatibilidad y tener el slug
            category: product.category ? [{
                name: product.category.name,
                slug: product.category.slug,
                id: product.category.id
            }] : [],
            tag: [product.brand || 'general'],
            stock: product.stock,
            // Guardamos las imágenes completas y también el array simple para compatibilidad
            images: product.images || [], 
            image: product.images?.map(img => img.image_path) || ['/assets/img/product/default.jpg'],
            shortDescription: product.description?.substring(0, 100) + '...',
            fullDescription: product.description,
            colors: product.colors || [],
            variation: product.variants?.map(variant => ({
              color: variant.color ? variant.color.name : (typeof variant.color === 'string' ? variant.color : null),
              size: [{
                name: variant.size,
                stock: variant.stock
              }]
            })) || []
          }));
          
          console.log('Transformed products:', transformedProducts);
          console.log('Categories found:', transformedProducts.map(p => p.category[0]));
          
          dispatch(setProducts(transformedProducts));
        } else {
          setError('Failed to fetch products');
        }
      } catch (err) {
        setError(err.message);
        console.error('Error fetching products:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [dispatch]);

  return { loading, error };
};

export default useProducts;
